import * as React from "react";
import { useMachine } from "@xstate/react";
import { Button } from "@nju/ui";
import { scanEsimQRCodeMachine } from "./scanEsimQRCode.machine";

interface IScanEsimQRCodeProps {
  iccId: string | undefined;
}

export function ScanEsimQRCode({ iccId }: IScanEsimQRCodeProps) {
  const [_, send] = useMachine(scanEsimQRCodeMachine, {
    context: {
      iccId,
    },
  });

  const handleScanQR = React.useCallback(() => {
    return send({ type: "SCAN_QR" });
  }, [send]);

  return (
    <Button
      onPress={() => {
        return handleScanQR();
      }}
      size={{ "@onlyMobile": "s" }}
    >
      zeskanuj kod QR
    </Button>
  );
}
